import React from 'react';
import { baseURL } from 'config/api.js';
import { useState, useEffect } from 'react';
import { AuthContext } from '../../context/AuthContext.jsx';
import { useContext } from 'react';
import { toast } from 'react-toastify';
import { ClipLoader } from 'react-spinners';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

export const AbsencesGraph = () => {
  const [absencesByEmployee, setAbsencesByEmployee] = useState(null);
  const [receivedData, setReceivedData] = useState(null);
  const [isLoadingError, setIsLoadingError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { userData } = useContext(AuthContext);

  useEffect(() => {

    async function fetchData() {
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userData.token
      };

      let getAbsencesURL = baseURL + "/reports/findAbsencesInPastMonths";
      const getAbsencesResponse = await fetch(getAbsencesURL, {
        method: "GET",
        headers: headers
      });
      const getAbsencesJSONData = await getAbsencesResponse.json();
      if (!getAbsencesResponse.ok) {
        toast.error(getAbsencesJSONData.data.message);
        setIsLoadingError(true);
        setIsLoading(false);
        return; //early return
      }

      setAbsencesByEmployee(getAbsencesJSONData.data.doc.employeesAndAbsences);
      setReceivedData(getAbsencesJSONData.data.doc);
      setIsLoading(false);
    }

    fetchData().catch(e => {
      setIsLoading(false);
      setIsLoadingError(true);
      toast.error("An error occurred while communicating with the server.");
    });
  }, []);

  if (isLoading) {
    return (
      <div className='p-4 mb-4 xl:mb-0 overflow-auto bg-white rounded-md shadow-md'>
        <div className='flex flex-row justify-between mb-4'>

          <div className='text-lg text-textPrimaryColor font-bold'>
            Absent days
          </div>

          <div className='text-sm font-semibold'>

          </div>

        </div>

        <div className='flex flex-row justify-around items-center h-52'>
          <ClipLoader size={17} color="#000" />
        </div>

      </div>

    );
  }
  if (!isLoading && isLoadingError) {
    return (
      <div className='p-4 mb-4 xl:mb-0 overflow-auto bg-white rounded-md shadow-md'>
        <div className='flex flex-row justify-between mb-4'>

          <div className='text-lg text-textPrimaryColor font-bold'>
            Absent days
          </div>

          <div className='text-sm font-semibold'>

          </div>

        </div>

        <div className='flex flex-row justify-around items-center h-52'>
          An error occurred.
        </div>

      </div>

    );
  }

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );

  const options = {
    responsive: true,
  };

  const labels = absencesByEmployee.map((element, index) => {
    return element[0];
  })

  const data = {
    labels,
    datasets: [
      {
        label: 'Absent days',
        data: absencesByEmployee.map((element, index) => {
          return element[1];
        }),
        backgroundColor: 'rgba(83, 89, 247, 1)',
      },
    ],
  };

  let rangeStartDate = new Date(Date.parse(receivedData.dtFirstMonthStart));
  let rangeEndDate = new Date(Date.parse(receivedData.dtLastMonthEnd));

  return (
    <div className='p-4 mb-4 xl:mb-0 overflow-auto bg-white rounded-md shadow-md'>
      <div className='flex flex-row justify-between items-center mb-4'>

        <div className='text-lg text-textPrimaryColor font-bold'>
          Absents days
        </div>

        <div className='text-sm font-semibold'>
          {rangeStartDate.toDateString()} - {rangeEndDate.toDateString()}
        </div>

      </div>

      <div>
        <Bar options={options} data={data} />
      </div>

    </div>
  );
}
